<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="typeCallingInstrument"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Tipos de Instrumento Convocatório"
        label-for="typeCallingInstrument"
      >
        <v-select
          id="typeCallingInstrument"
          v-model="typeCallingInstrument"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="nome"
          :options="dataOptions"
          :placeholder="'Tipos de Instrumento Convocatório'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ nome }">
            <span>{{ nome }}</span>
          </template>

          <template #selected-option="{ nome }">
            <span>{{ nome | truncate(truncateField, '...') }}</span>
          </template>

          <template #no-options>
            Não há opções de tipos de instrumento convocatório.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import truncate from '@/components/utils/filters/truncate'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'typeCallingInstrumentValue',
    event: 'typeCallingInstrumentChange',
  },
  props: {
    typeCallingInstrumentValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    truncateField: {
      type: Number,
      required: false,
      default: 17,
    },
  },
  data() {
    const dataOptions = []
    const newTypeCallingInstrumentValue = this.typeCallingInstrumentValue

    return {
      dataOptions,
      newTypeCallingInstrumentValue,
      required,
    }
  },
  computed: {
    typeCallingInstrument: {
      get() {
        return this.newTypeCallingInstrumentValue
      },
      set(value) {
        this.newTypeCallingInstrumentValue = value
        this.$emit('typeCallingInstrumentChange', this.newTypeCallingInstrumentValue)
      },
    },
  },
  watch: {
    typeCallingInstrumentValue(newVal) {
      this.newTypeCallingInstrumentValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .pncp
        .typeCallingInstrument
        .fetchTypeCallingInstruments()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['nome'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
